import React, {useEffect, useState} from 'react'
import PropTypes from "prop-types"
import ModalForm from '../../../../components/modalComponents/ModalForm'
import {v4 as uuidv4} from 'uuid';

import {
    activarInactivarTipoLicenciaCondicionAPI,
    agregarTipoLicenciaCondicionAPI,
    editarTipoLicenciaCondicionAPI,
    getAllTiposLicenciaCondicionesAPI,
} from "../../../../consumers/backendApisUrls";
import {useSubmitForm} from "../../../../hooks/useSubmitForm/useSubmitForm";
import {useManagePostRequest} from "../../../../hooks/useManagePostRequest/useManagePostRequest";
import TableWebBody from "./TableWebBody";
import {Spinner} from "react-bootstrap";
import SearchBar from "../../../../components/pageComponents/SearchBar";

const TiposLicencia = ({toggleModal}) => {
    const SECTION_NAME = "TiposLicenciaConfiguracion";
    const KEYS = ["IdTipoLicenciaCondicion" ,"Descripcion", "Abreviatura", "AlRegistrarLicencia_CampoMotivo_EsObligatorio" , "AlRegistrarLicencia_Mostrar_CampoHorario", "AlRegistrarLicencia_VisibleParaColaborador"]

    const [loading, setLoading] = useState(true);
    const [filas, setFilas] = useState([]);
    const [filasAntesDeSerEditadas, setFilasAntesDeSerEditadas] = useState([]);
    const [buttonDisabled, setButtonDisabled] = useState(false);

    const [managePostRequest] = useManagePostRequest();
    const [submitForm] = useSubmitForm();

    const [searchCriteria, setSearchCriteria] = useState("");

    const init = async () => {
        setLoading(true);
        try {
            await manageSearch(searchCriteria);
        } catch (error) {
            console.error(error);
        }
        setLoading(false);
    };

    const manageSearch = async (text) => {
        const api = getAllTiposLicenciaCondicionesAPI()
        let payload = {Criteria: text}
        await managePostRequest(api, payload, successGetAllCallBack, false);
    }

    const successGetAllCallBack = (res) => {
        let data = res.data;
        setFilas(data);
    }

    const onSubmit = async (fila) => {
        let api = "";
        fila.Nueva
            ? (api = agregarTipoLicenciaCondicionAPI())
            : (api = editarTipoLicenciaCondicionAPI())
        await submitForm(KEYS, api, fila, SECTION_NAME, successSubmitCallback);
    }

    const successSubmitCallback = () => {
        manageSearch(searchCriteria);
        setButtonDisabled(false);
    }

    const cancelarSubmit = (id) => {
        if(typeof id != 'string'){
            const filaOriginal = filasAntesDeSerEditadas.filter(o => o.IdTipoLicenciaCondicion == id)[0];
            const insertFilaOriginal = filas.map(fila => {
                if(fila.IdTipoLicenciaCondicion == id){
                    fila = filaOriginal;
                }
                return fila;
            });
            setFilas(insertFilaOriginal);
            const clearFilaOriginal = filasAntesDeSerEditadas.filter(filaEditar => filaEditar.IdTipoLicenciaCondicion != id);
            setFilasAntesDeSerEditadas(clearFilaOriginal);
        } else {
            const clearFilaOriginal = filas.filter(fila => fila.IdTipoLicenciaCondicion != id);
            setFilas(clearFilaOriginal);
            setButtonDisabled(false);
        }
    }

    const addFilaToList = (e) => {
        if (e) e.preventDefault();
        setButtonDisabled(true);

        let emptyFila = {
            IdTipoLicenciaCondicion: uuidv4(),
            Nueva: true,
            Editable: true,
            Categoria: "Otro Tipo Licencia",
            AlRegistrarLicencia_CampoMotivo_EsObligatorio: true,
            AlRegistrarLicencia_Mostrar_CampoHorario: true,
            AlRegistrarLicencia_VisibleParaColaborador: true,
        }

        let newFilas = [emptyFila, ...filas];
        setFilas(newFilas);
    }

    const editarFila = (obj) => {
        const filaOriginal = {...obj};
        setFilasAntesDeSerEditadas([...filasAntesDeSerEditadas, filaOriginal]);
        const Editable = filas.map(fila => {
            if (fila.IdTipoLicenciaCondicion === obj.IdTipoLicenciaCondicion){
                fila.Editable = true;
            }
            return fila;
        });
        setFilas(Editable)
    }

    const activarInactivar = async (id) => {
        const api = activarInactivarTipoLicenciaCondicionAPI(id)
        await managePostRequest(api, {}, successActivarInactivarCallBack, true);
    }

    const successActivarInactivarCallBack = (res) => {
         manageSearch(searchCriteria)
    }
    
    useEffect(() => {
        let unmounted = false;
        if (!unmounted) {
            init();
        }

        return () => {
            unmounted = true;
        };
    }, []);


    if (loading) {
        return (
            <div className="spinner-cargando-container">
                <Spinner animation="grow" variant="primary" size="1sm" />
            </div>
        );
    }

    const limpiarBusqueda = async () => {
        setSearchCriteria("");
        await manageSearch("");
    };

    return (
        <ModalForm
            titulo="Tipos de Licencia"
            width="1300px"
            showModal={toggleModal}
            hasSaveButton={false}
        >

            <div className="generic-buscador-container mt-0 pt-0 pb-1">
                <SearchBar placeholder={"Buscar por Descripción o Abreviatura"} value={searchCriteria} onChange={setSearchCriteria} cleanSearch={limpiarBusqueda} manageSearch={()=>manageSearch(searchCriteria)} />
                <div className="filtros-right-section">
                    <button
                        onClick={addFilaToList}
                        type="button"
                        className="generic-button-buscador"
                        disabled={buttonDisabled}
                    >
                        Agregar
                    </button>
                </div>
            </div>

            <div>
                <div className="container-fluid body-content">
                    <div className="table-responsive form-group-sm pt-2">
                        <table className="table table-hover">
                            <thead className="listar-thead">
                            <tr>
                                <th style={{width:"60%"}}>
                                    <div className="flex font-gothan-medium">Descripción</div>
                                </th>
                                <th style={{width:"20%"}}>
                                    <div className="flex font-gothan-medium">Abreviatura</div>
                                </th>
                                <th style={{width:"5%"}}>
                                    <div className="flex font-gothan-medium">Motivo</div>
                                </th>
                                <th style={{width:"5%"}}>
                                    <div className="flex font-gothan-medium">Horario</div>
                                </th>
                                <th style={{width:"5%"}}>
                                    <div className="flex font-gothan-medium">Visible</div>
                                </th>
                                <th style={{width:"5%"}}>
                                    <div className="flex font-gothan-medium">Acciones</div>
                                </th>
                            </tr>
                            </thead>
                            <TableWebBody
                                filas={filas}
                                setFilas={setFilas}
                                editarFila={editarFila}
                                onSubmit={onSubmit}
                                cancelarSubmit={cancelarSubmit}
                                activarInactivar={activarInactivar}
                            />
                        </table>

                    </div>
                </div>

            </div>


        </ModalForm>
    );
}

TiposLicencia.propTypes = {
    toggleModal: PropTypes.func.isRequired,
    refreshPage: PropTypes.func
}

export default TiposLicencia;